import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";

//COMPONENTS
import ViewController from "./files/controller";
import ProduceAStatement from "./files/produceAStatement";
import MorePayments from "./files/moreSettings";

function PodRouter() {
    const [isLoaded, setIsLoaded] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        setIsLoaded(true);
    }, []);

    return (
        <div>
            {isLoaded && (
                <div>
                    <Routes>
                        <Route path="/" element={<ViewController />} />
                        <Route path="/produceReceipt" element={<ProduceAStatement type="receipt" />} />
                        <Route path="/produceInvoice" element={<ProduceAStatement type="invoice" />} />
                        <Route path="/moreSettings" element={<MorePayments />} />
                    </Routes>
                </div>
            )}
        </div>
    );
}

export default PodRouter;
